import React from 'react';
import classNames from 'classnames';

import css from './IconPlus.module.css';

/**
 * IconPlus component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {boolean} [props.isOpen] - Whether the icon is showing the 'open' mode
 * @returns {JSX.Element}
 */
const IconPlus = props => {
  const { className, rootClassName, isOpen = true } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    // <svg className={classes} width="12" height="12" xmlns="http://www.w3.org/2000/svg">
    //   <line className={css.horizontalLine} x1="0" y1="6" x2="11" y2="6" strokeWidth="1.9" />
    //   <line
    //     className={classNames(css.verticalLine, { [css.lineVerticalOpen]: isOpen })}
    //     x1="0"
    //     y1="6"
    //     x2="11"
    //     y2="6"
    //     strokeWidth="1.9"
    //   />
    // </svg>
    <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="20px"
    height="20px"
    viewBox="0 0 480 480"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(0,480) scale(0.1,-0.1)" fill={css.colorGrey800} stroke="none">
      <path
        d="M1769 4489 c-52 -31 -69 -73 -69 -174 l0 -85 -371 0 c-363 0 -372 0
-410 -22 -25 -14 -46 -36 -58 -62 -19 -39 -20 -74 -24 -656 -5 -663 -6 -686
-67 -980 -118 -565 -378 -1087 -688 -1382 -54 -50 -72 -75 -77 -102 -13 -67
19 -131 79 -160 29 -14 83 -16 395 -16 l361 0 0 -218 c0 -206 1 -220 22 -262
14 -27 36 -50 58 -62 33 -17 114 -18 1900 -18 1756 0 1867 1 1899 18 19 9 44
30 55 45 l21 28 3 1857 c2 1304 0 1868 -8 1894 -7 24 -24 48 -47 65 l-36 28
-374 3 -373 3 0 77 c0 133 -60 209 -156 199 -90 -9 -134 -76 -134 -202 l0 -75
-355 0 -355 0 0 89 c0 75 -3 93 -23 122 -62 93 -189 87 -239 -12 -13 -24 -18
-58 -18 -116 l0 -83 -350 0 -350 0 0 83 c0 125 -41 185 -131 193 -33 4 -53 -1
-80 -17z m-69 -629 c0 -99 12 -134 56 -169 19 -15 41 -21 76 -21 103 0 148 61
148 198 l0 82 350 0 350 0 0 -86 c0 -97 20 -148 70 -177 39 -24 115 -22 150 3
44 32 60 77 60 174 l0 86 355 0 355 0 0 -80 c0 -93 14 -135 59 -173 46 -39
126 -39 172 0 45 38 59 80 59 173 l0 80 280 0 280 0 0 -285 0 -285 -1695 0
-1695 0 0 285 0 285 285 0 285 0 0 -90z m2814 -822 c-38 -517 -148 -945 -341
-1322 -81 -159 -226 -375 -327 -488 l-87 -98 -1644 0 c-999 0 -1645 4 -1645 9
0 5 11 22 23 38 60 72 189 283 259 423 128 256 187 415 253 680 67 268 115
584 115 758 l0 62 1699 0 1699 0 -4 -62z m6 -1863 l0 -605 -1695 0 -1695 0 0
140 0 140 1352 0 c1568 0 1383 -16 1519 128 164 172 358 464 464 697 27 58 50
105 52 105 1 0 3 -272 3 -605z"
      />
    </g>
  </svg>
  );
};

export default IconPlus;
